if (!customElements.get('kuden-mto-options')) {
  class KudenMtoOptions extends HTMLElement {
    connectedCallback() {
      this.form = document.getElementById(this.dataset.formId);
      this.status = this.querySelector('[data-kuden-mto-status]');
      this.submitButton = this.form?.querySelector('[name="add"]');

      this.addEventListener('change', this.updateCompletionState.bind(this));
      this.updateCompletionState();
    }

    updateCompletionState() {
      const requiredInputs = [...this.querySelectorAll('input[required]')];
      const isComplete = requiredInputs.length > 0 && requiredInputs.every((input) => input.checkValidity());

      this.toggleAttribute('data-complete', isComplete);

      if (this.status) {
        this.status.hidden = isComplete;
      }

      if (this.submitButton) {
        this.submitButton.classList.toggle('kuden-mto-submit--incomplete', !isComplete);
      }
    }
  }

  customElements.define('kuden-mto-options', KudenMtoOptions);
}
